{
  "fr": {
    "add": "Créer",
    "search": "Rechercher",
    "loading_more": "Chargement...",
    "no_more_results": "Pas de résultats supplémentaires",
    "no_results": "Aucun résultat",
    "happy_birthday": "Aujourd'hui c'est l'anniversaire de %{name}, joyeux anniversaire ! 🎉",
    "filters_count": {
      "one": "1 filtre appliqué",
      "other": "%{count} filtres appliqués"
    },
    "file_input_error": "Veuillez importer au moins un fichier",
    "copy_to_clipboard": "Copié dans le presse-papiers",
    "dataroom_dropzone": {
      "too_many_files": "Vous ne pouvez importer que %{smart_count} fichiers à la fois.",
      "invalid_file_type": "Format non autorisé.",
      "file_too_large": "Fichier > 100 Mo.",
      "leave_confirm": "Un import est en cours. Si vous quittez la page, il sera annulé. Continuer ?",
      "import_window": {
        "title": {
          "one": "Importation de %{count} élément",
          "other": "Importation de %{count} éléments"
        },
        "in_progress": "Importation en cours ...",
        "done": "Importation terminée",
        "done_with_errors": {
          "one": "Importation terminée - %{count} erreur",
          "other": "Importation terminée - %{count} erreurs"
        },
        "cancelled": "Importation annulée",
        "folder_count": "%{done} sur %{total}",
        "failed_files": {
          "one": "%{count} fichier non importé",
          "other": "%{count} fichiers non importés"
        },
        "error_generic": "Une erreur est survenue, réessayez plus tard."
      }
    }
  }
}
